import React, { useState, useEffect, useContext } from "react";
import axios from "../../../axios/index";
import { Link } from "react-router-dom";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// styles
import styles from "./UserRequestFile.module.css";
import Dstyles from "../UserMyAds/UserMyAds.module.css";
import loaderStyles from "../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "./../../Home/HomeNavbar/HomeNavbar";
import UserSideDashboard from "../UserSideDashboard/UserSideDashboard";
import Footer from "../../Home/Footer/Footer";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import CustomPagination from "../../CustomPagination/CustomPagination";

export default function UserRequestFile() {
  const { userToken } = useContext(UserContext);
  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [filesData, setfilesData] = useState([]);

  useEffect(() => {
    const dataHandler = async () => {
      // setIsLoading(true)

      const getRequestes = await axios.get("RequestFile/FilterForUser", {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(getRequestes)

      setPage(prev => {
        return { ...prev, pageNumber: 1, pageCount: getRequestes.data.data.pageCount };
      });
      const requests = getRequestes.data.data.data;
      setfilesData(requests);

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken]);

  return (
    <>
      {isLoading ? (
        <div className={loaderStyles.loader_container}>
          <div className={loaderStyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar />
            <div className="container py-3 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard myReqs />
                <div className={`d-flex flex-column align-items-center justify-content-start p-4 ${Dstyles.main_container}`}>
                  <div className="w-100 d-flex flex-md-row flex-column align-items-center justify-content-md-between justify-content-center flex-wrap mb-5">
                    <div className={`my-md-0 my-2 ${Dstyles.title}`}>درخواست ملک</div>

                    <Link to="/user-add-request-file" className={`my-md-0 my-2 ${styles.text_primary}`}>
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-2">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8 0.5C8.41421 0.5 8.75 0.835786 8.75 1.25V7.25H14.75C15.1642 7.25 15.5 7.58579 15.5 8C15.5 8.41421 15.1642 8.75 14.75 8.75H8.75V14.75C8.75 15.1642 8.41421 15.5 8 15.5C7.58579 15.5 7.25 15.1642 7.25 14.75V8.75H1.25C0.835786 8.75 0.5 8.41421 0.5 8C0.5 7.58579 0.835786 7.25 1.25 7.25H7.25V1.25C7.25 0.835786 7.58579 0.5 8 0.5Z"
                          fill="#21409A"
                        />
                      </svg>
                      درخواست جدید
                    </Link>
                  </div>

                  <div className="w-100 d-flex flex-column align-items-center justify-content-center mb-5" style={{ minHeight: "397px" }}>
                    {filesData == "" ? (
                      <div className={`w-100 d-flex align-items-center justify-content-center text-end ${styles.title}`}>
                        هنوز هیچ موردی برای نمایش وجود ندارد
                      </div>
                    ) : (
                      filesData?.map(item => (
                        <div
                          key={item.id}
                          className={`w-100 d-flex flex-column align-items-start justify-content-center flex-wrap p-3 my-3 ${styles.file_container}`}>
                          <h5 className={`w-100 text-end mt-2 mb-3 ${styles.title}`}>{e2p(item.title?.toString())}</h5>
                          <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center mt-3 mb-2 flex-wrap">
                            <div className={`my-md-0 my-3 ${styles.text_dark}`}>
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-2">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.99935 1.94856C5.10503 1.94856 1.94807 5.10552 1.94807 8.99984C1.94807 12.8942 5.10503 16.0511 8.99935 16.0511C12.8937 16.0511 16.0506 12.8942 16.0506 8.99984C16.0506 5.10552 12.8937 1.94856 8.99935 1.94856ZM0.666016 8.99984C0.666016 4.39746 4.39698 0.666504 8.99935 0.666504C13.6017 0.666504 17.3327 4.39746 17.3327 8.99984C17.3327 13.6022 13.6017 17.3332 8.99935 17.3332C4.39698 17.3332 0.666016 13.6022 0.666016 8.99984Z"
                                  fill="#8D8D8D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.99938 4.08531C9.35341 4.08531 9.64041 4.3723 9.64041 4.72633V8.99984C9.64041 9.16985 9.57287 9.3329 9.45266 9.45311L6.88854 12.0172C6.6382 12.2676 6.23233 12.2675 5.98199 12.0172C5.73166 11.7669 5.73166 11.361 5.98199 11.1107L8.35836 8.73431V4.72633C8.35836 4.3723 8.64535 4.08531 8.99938 4.08531Z"
                                  fill="#8D8D8D"
                                />
                              </svg>
                              {e2p(item.createDate?.toString())}
                            </div>
                            <div className="d-flex align-items-center justify-content-center mx-md-0 mx-5 my-md-0 my-2">
                              <div className={`ms-2 ${styles.text_gray}`}>وضعیت: </div>
                              <div className={styles.text_success}>{item.isAnswered ? "پاسخ داده" : " پاسخ نداده"}</div>
                            </div>
                            <Link
                              to={{
                                pathname: `/user-request-file-detail/${item.id}`,
                                state: item,
                              }}
                              className={`mt-md-0 mt-3 mb-md-0 mb-2 ${styles.text_primary}`}>
                              بیشتر
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M6.15533 11.0303C5.86244 11.3232 5.38756 11.3232 5.09467 11.0303L0.59467 6.53033C0.301776 6.23744 0.301776 5.76256 0.59467 5.46967L5.09467 0.969671C5.38756 0.676777 5.86244 0.676777 6.15533 0.969671C6.44822 1.26256 6.44822 1.73744 6.15533 2.03033L2.93566 5.25L10.875 5.25C11.2892 5.25 11.625 5.58579 11.625 6C11.625 6.41421 11.2892 6.75 10.875 6.75L2.93566 6.75L6.15533 9.96967C6.44822 10.2626 6.44822 10.7374 6.15533 11.0303Z"
                                  fill="#21409A"
                                />
                              </svg>
                            </Link>
                          </div>
                        </div>
                      ))
                    )}
                  </div>

                  <Stack
                    className={loaderStyles.pagination}
                    spacing={1}
                    sx={{
                      direction: "ltr",
                      bottom: "0",
                      height: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center !important",
                    }}>
                    <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                  </Stack>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  async function paginationHandler(value) {
    setIsLoading(true);
    const getApiData = await axios.get(`RequestFile/FilterForUser?PageId=${value}`, {
      headers: { authorization: "Bearer " + userToken },
    });
    setPage(prev => {
      return { ...prev, pageCount: getApiData.data.data.pageCount, pageNumber: value };
    });
    setfilesData(getApiData.data.data.data);
    setIsLoading(false);
  }
}
